export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('request:before', () => {
    const style = document.createElement('style')
    style.textContent = `
      .UNotification,
      .notification-wrapper,
      .nuxt-ui-notifications {
        z-index: 1100 !important;
      }
    `
    document.head.appendChild(style)
  })
})